/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { GetMeOptions, GetMeResponses } from '../models/GetMe'
import { client } from '#shared/api/client'

/**
 * @description Answers an upgrade session too, with the guest it belongs to
 * (`accountType: "guest"`): the one read open to it, so the frontend can
 * tell a guest from a signed-out browser (ADR 0018).
 * @summary The signed-in account.
 * {@link /api/me}
 */
export function getMe<ThrowOnError extends boolean = true>(options: Options<GetMeOptions, ThrowOnError> = {}): Promise<RequestResult<GetMeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'GET', url: '/api/me', security: [{ type: 'apiKey', name: 'cas_session', in: 'cookie' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetMeResponses, ThrowOnError>>
}
